import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { get } from 'lodash';
import { useHistory } from 'react-router-dom';

import { trialSignupVerify } from '../../store/signup/signupAction';
import OtpForm from '../validate/OtpForm';
import Header from '../../components/Header';

/**
 * Free trial signuo verification
 * @param {*} props
 */
const TrialVerification = (props) => {
    const history = useHistory();
    const { trialFormData, trialSignupVerify } = props;
    const [loader, setLoader] = useState(false);

    window.dataLayer.push({
        event: 'pageview',
        page: {
            url: document.location.pathname,
            title: ''
        }
    });

    useEffect(() => {
        if (!trialFormData) {
            history.push('/trial');
        }
    }, [trialFormData, history]);
    /**
     * Verify OTP
     * @param {*} formData
     */
    const verifyOTP = (formData) => {
        setLoader(true);

        return trialSignupVerify({
            ...formData,
            form_id: get(trialFormData, 'data.form_id', null),
        }).then((res) => {
            if (res.status !== 'success') {
                setLoader(false);
                throw new SubmissionError({
                    otp: 'Verification code entered is invalid',
                    _error: 'verification failed',
                });
            } else {
                history.push('/completed/trial');
            }
            setLoader(false);
        });
    };
    return (
        <div className="container">
            <Header />
            {loader && <div class="loader"></div>}
            <div className="content validate">
                <div className="content-block-right">
                    <div className="sec-header-block">
                        <h1>Verify</h1>
                        <p>
                            Enter the verification code sent to your business
                            email to complete the signup.
                        </p>
                    </div>
                    <OtpForm
                        verifyOTP={verifyOTP}
                        formId={get(trialFormData, 'data.form_id')}
                        otpLabel={null}
                    />
                </div>
            </div>
        </div>
    );
};

const mapDispatchToProps = {
    trialSignupVerify,
};
const mapStateToProps = (store, props) => ({
    trialFormData: get(store, 'signupReducer.trialFormData', null),
});

export default connect(mapStateToProps, mapDispatchToProps)(TrialVerification);
